import React, { useState, useEffect } from 'react';
import styles from './UserVoter.module.css';
import * as Yup from 'yup';
import CommonInput from '../../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonPincode from '../../../../components/Dashboard-res/CommonComponent/CommonPincode';
import male_icon from '../../../../images/icons/UserKycIcons/male_icon.svg';
import female_icon from '../../../../images/icons/UserKycIcons/female_icon.svg';
import common_gender from '../../../../images/icons/UserKycIcons/common_gender.svg';
import selectGender_icon from '../../../../images/icons/UserKycIcons/selectGender_icon.svg';
import initialImg from '../../../../images/icons/upload_new.svg';
import { StateListOptions } from '../../../../common/constants/StateList';

import CommonDatePicker, {
  currentYear
} from '../../../../components/Dashboard-res/CommonComponent/CommonDatePicker';
import get from 'lodash/get';
import GlobalUploadComp from '../../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { Formik, Form } from 'formik';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';
import {
  UserKycUpload,
  UploadFileToS3,
  UserKycOcr,
  UserKycVarifyDetails,
  GETAPI
} from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { GetImgComp } from './GetImgComp';

const validationSchema = Yup.object().shape({
  file: Yup.array().when('isEditMode', {
    is: false,
    then: Yup.array()
      .min(2, 'must upload 2 files atleast')
      .required('file is required')
      .of(Yup.string().required())
  }),

  imgUrl: Yup.string().when('isEditMode', {
    is: false, // alternatively: (val) => val == true
    then: Yup.string().required(' required')
  }),
  gender: Yup.string().required('Required'),

  fullName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  fatherName: Yup.string()
    .min(1, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  date: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  month: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  year: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  voterId_No: Yup.string().required('Required'),
  address_line1: Yup.string().required('Required'),
  address_line2: Yup.string().required('Required'),
  city: Yup.string().required('Required'),
  state: Yup.object().shape({
    value: Yup.string().required('Required')
  }),
  pincode: Yup.string()
    .required('Required')
    .max(6, 'Pincode should be 6 digit numbers')
    .matches(/\d{6}/, 'Pincode should be digits only')
});

const UserVoterDetails = props => {
  const {
    voter_container,
    voter_details,
    align_city_state,
    align_state,
    gender,
    genderBox,
    check
  } = styles;

  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        gender: '',
        fullName: '',
        isEditMode: false,
        fatherName: '',
        date: {
          value: '',
          label: 'Date'
        },
        month: {
          value: '',
          label: 'Month'
        },
        year: {
          value: String(parseInt(currentYear) - 18),
          label: String(parseInt(currentYear) - 18)
        },
        voterId_No: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: { value: '', label: 'Select State' },

        pincode: '',
        pincodeCity: '',
        pincodeState: ''
      }}
      validationSchema={validationSchema}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        props.handleSubmit();
      }}
    >
      {({
        values: data,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        setFieldError,
        isSubmitting,
        setValues
      }) => {
        const [Loading, setLoading] = useState(false);
        const [LoadingFail, setLoadingFail] = useState(false);
        const [saveAndVerifyRes, setSaveAndVerifyRes] = useState(false);
        const [uploadDone, setUploadDone] = useState(false);
        const [isSubmit, setSubmit] = useState(false);

        const [DocIdFront, setFrontDocId] = useState(false);
        const [docIdBack, setBackDocId] = useState(false);
        const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
        //
        const [imgLinkData, setImgLinkData] = useState(null);
        const [applicantId, setApplicantId] = useState(
          getApplicantionInfo().leadApplicantId
        );
        const [Edit1, setEdit1] = useState(false);
        const [Edit2, setEdit2] = useState(false);
        async function getVoter() {
          let isError = false;
          const res = await GETAPI(leadId, applicantId, 'voterId').catch(
            err => {
              setLoading(true);

              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
              isError = true;
            }
          );

          if (!isError) {
            const { links, userData } = res;

            // parsing logic here
            setImgLinkData({
              front: links?.[0],
              back: links?.[1]
            });

            setValues({
              ...data,
              file: [],
              imgUrl: [],
              gender: '',
              fullName: userData?.name || '',
              isEditMode: !!(links?.[0] || links?.[1]),
              fatherName: userData?.fatherName || '',
              date: {
                value: '',
                label: 'Date'
              },
              month: {
                value: '',
                label: 'Month'
              },
              year: {
                value: String(parseInt(currentYear) - 18),
                label: String(parseInt(currentYear) - 18)
              },
              voterId_No: userData?.voterIdNumber || '',
              address_line1: userData?.address?.line1 || '',
              address_line2: userData?.address?.line2 || '',
              city: userData?.address?.city || '',
              state: {
                label: userData?.address?.state,
                value: userData?.address?.state
              },
              pincode: userData?.address?.pinCode || '',
              pincodeCity: '',
              pincodeState: ''
            });
            if (data?.imgUrl?.[0] || data?.imgUrl?.[1]) {
              setUploadDone(true);
            }
          }
        }
        useEffect(() => {
          getVoter();
        }, []);

        useEffect(() => {
          setUploadDone(false);
          setSubmit(false);
          if (data?.imgUrl?.[0] && data?.imgUrl?.[1]) {
            setValues({
              ...data,
              gender: '',
              fullName: '',
              fatherName: '',
              month: {
                value: '',
                label: 'Month'
              },
              date: {
                value: '',
                label: 'Date'
              },
              year: {
                value: String(parseInt(currentYear) - 18),
                label: String(parseInt(currentYear) - 18)
              },
              voterId_No: '',
              address_line1: '',
              address_line2: '',
              city: '',
              state: '',
              pincode: '',
              pincodeCity: '',
              pincodeState: ''
            });
          }
        }, [data?.imgUrl?.[0], data?.imgUrl?.[1]]);
        async function showVoterDetails() {
          /** Front upload**/
          const isFrontImageAvailable = data?.imgUrl?.[0];
          const isSecondImageAvailable = data?.imgUrl?.[1];

          if (!isFrontImageAvailable && !isSecondImageAvailable) {
            return;
          }

          setLoading(true);

          let responseFront = {};
          let responseBack = {};
          if (isFrontImageAvailable) {
            try {
              responseFront = await UserKycUpload(
                data.file[0],
                leadId,
                applicantId,
                'voterId',
                'voterFront'
              );
              setFrontDocId(responseFront.requestId);
            } catch (e) {
              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
            }
            await UploadFileToS3(responseFront.url, data.file[0][0]);
          }

          /**
           * Back upload
           */
          if (isSecondImageAvailable) {
            try {
              responseBack = await UserKycUpload(
                data.file[1],
                leadId,
                applicantId,
                'voterId',
                'voterBack'
              );
              setBackDocId(responseBack.requestId);
            } catch (e) {
              setLoadingFail({
                message:
                  err?.response?.data?.message || 'Something went wrong !',
                status: err?.response?.data?.status
              });
            }
            await UploadFileToS3(responseBack.url, data.file[1][0]);
          }
          setLoading(true);
          /**
           * Front Ocr
           */
          let ocrFrontResponse = {};
          let ocrBackResponse = {};
          if (isFrontImageAvailable) {
            try {
              ocrFrontResponse = await UserKycOcr(
                leadId,
                applicantId,
                responseFront.requestId,
                'voterId'
              );
              setUploadDone(true);
            } catch (err) {
              //alert(err, 'fghfhfg');
              setLoading(true);
              setLoadingFail(true);
              setUploadDone(false);
            }
          }

          /**
           * Back ocr
           */
          if (isSecondImageAvailable) {
            try {
              ocrBackResponse = await UserKycOcr(
                leadId,
                applicantId,
                responseBack.requestId,
                'voterId'
              );
              setUploadDone(true);
            } catch (err) {
              setLoading(true);
              setLoadingFail(true);
              setUploadDone(false);
            }
          }

          setLoading(false);

          let dob =
            ocrFrontResponse?.kycEntries?.dob?.value.toString().split('/') ||
            ocrBackResponse?.kycEntries?.dob?.value.toString().split('/');
          setFieldValue('year', {
            value: dob?.[2] || '2002',
            label: dob?.[2] || '2002'
          });
          setFieldValue('month', {
            value: dob?.[1] || '',
            label: dob?.[1] || 'month'
          });
          setFieldValue('date', {
            value: dob?.[0] || '',
            label: dob?.[0] || 'date'
          });
          setFieldValue(
            'voterId_No',
            ocrFrontResponse?.kycEntries?.voterId?.value ||
              ocrBackResponse?.kycEntries?.voterId?.value
          );
          setFieldValue(
            'gender',
            ocrFrontResponse?.kycEntries?.gender?.value ||
              ocrBackResponse?.kycEntries?.gender?.value
          );
          setFieldValue(
            'fullName',
            ocrFrontResponse?.kycEntries?.name?.value ||
              ocrBackResponse?.kycEntries?.name?.value
          );
          setFieldValue(
            'fatherName',
            ocrFrontResponse?.kycEntries?.relativeName?.value ||
              ocrBackResponse?.kycEntries?.relativeName?.value
          );
          let splitAddress =
            ocrFrontResponse?.kycEntries?.address?.value
              .toString()
              .split(/,|- /) ||
            '' ||
            ocrBackResponse?.kycEntries?.address?.value
              .toString()
              .split(/,|- /) ||
            '';

          let addressline1 = splitAddress?.slice(0, 2).toString() || '';
          let addressline2 = splitAddress?.slice(2).toString() || '';
          setFieldValue('address_line1', addressline1);
          setFieldValue('address_line2', addressline2);
          /////
          setLoading(false);

          setSubmit(true);
        }

        async function saveAndVerify() {
          setLoading(true);
          let body = {
            name: data?.fullName,
            gender: data?.gender,
            fatherName: data?.fatherName,
            voterIdNumber: data?.voterId_No,
            address: {
              line1: data?.address_line1,
              line2: data?.address_line2,
              city: data?.city,
              state: data.state.value,
              pinCode: data?.pincode
            },
            dob:
              data?.year?.value +
              '-' +
              (data?.month?.value < 10
                ? '0' + data?.month?.value
                : data?.month?.value) +
              '-' +
              (data?.date?.value < 10
                ? '0' + data?.date?.value
                : data?.date?.value)
          };

          try {
            const resVerifyFront = await UserKycVarifyDetails(
              leadId,
              applicantId,
              body,
              'voterId'
            );
            setSaveAndVerifyRes(resVerifyFront);
          } catch (e) {
            console.log(e);
          }
          try {
            const resVerifyBack = await UserKycVarifyDetails(
              leadId,
              applicantId,
              body,
              'voterId'
            );
            setSaveAndVerifyRes(resVerifyBack);
          } catch (e) {
            console.log(e);
          }
          setLoading(false);
          // redirect logic
        }
        const shouldShowNextButton = data.file.length >= 1;

        function getLoadingMsg() {
          if (typeof LoadingFail !== 'boolean') {
            if (LoadingFail) return LoadingFail?.message;
          }
          return <p>Loading ...</p>;
        }
        return (
          <React.Fragment>
            {Loading ? (
              <PopUp
                goto={LoadingFail.status == 403}
                dontClose={LoadingFail?.status == 403}
                type={LoadingFail?.message ? 'fail' : 'loading'}
                text={getLoadingMsg()}
                show={Loading}
                setShow={setLoading}
              />
            ) : null}

            <Form
              autoComplete="off"
              onSubmit={handleSubmit}
              className="pt-2 sm:px-5 "
            >
              <div className={`${voter_container}`}>
                <p className="text-lg p-5 text-black-850 font-roboto font-medium">
                  Upload Voter ID
                </p>
                <div className="flex flex-wrap justify-around  p-5">
                  <div className="md:pb-5 ">
                    {imgLinkData?.front && !Edit1 ? (
                      <GetImgComp
                        imgUrl={imgLinkData?.front?.url}
                        setEdit={setEdit1}
                      />
                    ) : (
                      <GlobalUploadComp
                        data={data}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage // boolean , to change mobile upload image view
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload "
                        subtext="CHOOSE FRONT VIEW "
                      />
                    )}
                  </div>
                  {imgLinkData?.back && !Edit2 ? (
                    <GetImgComp
                      imgUrl={imgLinkData?.back?.url}
                      setEdit={setEdit2}
                    />
                  ) : (
                    <GlobalUploadComp
                      data={data}
                      imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                      errors={errors}
                      touched={touched}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      setFieldValue={setFieldValue}
                      setFieldTouched={setFieldTouched}
                      setFieldError={setFieldError}
                      showFullImage // boolean , to change mobile upload image view
                      initialImg={initialImg} // initial image
                      subInst="Click here to upload "
                      subtext="CHOOSE BACK VIEW"
                    />
                  )}
                </div>
                {!isSubmit && shouldShowNextButton && (
                  <button
                    type="button"
                    className={`submitButton w-48`}
                    onClick={() => showVoterDetails()}
                  >
                    UPLOAD
                  </button>
                )}
                {(uploadDone || imgLinkData?.back || imgLinkData?.front) && (
                  <>
                    <div className={`${voter_details} px-5 md:px-0`}>
                      <div className={`${gender}`}>
                        <p className="text-base md:text-lg text-black-500 font-roboto pb-4">
                          Gender
                        </p>
                        <div className={`${genderBox}`}>
                          <div className="relative">
                            <img
                              src={selectGender_icon}
                              alt=""
                              className={`${
                                data.gender == 'MALE' ? check : 'hidden'
                              }`}
                            />
                            <img
                              className={`${
                                data.gender == 'MALE'
                                  ? 'opacity-100'
                                  : 'opacity-50'
                              } cursor-pointer hover:opacity-25`}
                              src={male_icon}
                              alt=""
                              onClick={e => {
                                setFieldValue('gender', 'MALE');
                              }}
                            />
                          </div>
                          <div className="relative">
                            <img
                              src={selectGender_icon}
                              alt=""
                              className={`${
                                data.gender == 'FEMALE' ? check : 'hidden'
                              }`}
                            />

                            <img
                              className={`${
                                data.gender == 'FEMALE'
                                  ? 'opacity-100'
                                  : 'opacity-50'
                              } cursor-pointer hover:opacity-25`}
                              src={female_icon}
                              alt=""
                              onClick={e => {
                                setFieldValue('gender', 'FEMALE');
                              }}
                            />
                          </div>
                          <div className="relative">
                            <img
                              src={selectGender_icon}
                              alt=""
                              className={`${
                                data.gender == 'common' ? check : 'hidden'
                              }`}
                            />

                            <img
                              className={`${
                                data.gender == 'common'
                                  ? 'opacity-100'
                                  : 'opacity-50'
                              } cursor-pointer hover:opacity-25`}
                              src={common_gender}
                              alt=""
                              onClick={e => {
                                setFieldValue('gender', 'common');
                                // setGenderFun(data.gender);
                              }}
                            />
                          </div>
                        </div>
                        <p className="text-xs pt-2 text-red-300">
                          {errors.gender}
                        </p>
                      </div>
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="fullName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.fullName}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Full Name"
                          error={touched.fullName && errors.fullName}
                          errorMsg={errors.fullName}
                          touched={touched.fullName}
                        />
                      </div>
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="fatherName"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.fatherName}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Father’s Name"
                          error={touched.fatherName && errors.fatherName}
                          errorMsg={errors.fatherName}
                          touched={touched.fatherName}
                        />
                      </div>
                      <div
                        className=" mb-7"
                        style={{
                          position: 'relative',
                          top: '-25px'
                        }}
                      >
                        <div className="text-black-600 font-roboto font-normal text-xs pb-2">
                          DOB
                        </div>
                        <CommonDatePicker
                          onChangeMonth={(value, isValidDate) => {
                            setFieldValue('month', value, true);
                            setFieldTouched('month', true, false);
                            if (!isValidDate) {
                              setFieldValue(
                                'date',
                                {
                                  value: '',
                                  label: 'Date'
                                },
                                true
                              );
                            }
                          }}
                          onChangeYear={(value, isValidDate) => {
                            setFieldValue('year', value, true);
                            setFieldTouched('year', true, false);

                            if (!isValidDate) {
                              setFieldValue(
                                'date',
                                {
                                  value: '',
                                  label: 'Date'
                                },
                                true
                              );
                            }
                          }}
                          onChangeDate={value => {
                            setFieldValue('date', value, true);
                            setFieldTouched('date', true, false);
                          }}
                          valueMonth={data.month}
                          valueYear={data.year}
                          valueDate={data.date}
                          errorYear={
                            touched.year && get(errors, 'year.value', false)
                          }
                          touchedYear={touched.year}
                          onBlurYear={() => {
                            setFieldTouched('year', true, true);
                          }}
                          errorMonth={
                            touched.month && get(errors, 'month.value', false)
                          }
                          touchedMonth={touched.month}
                          onBlurMonth={() => {
                            setFieldTouched('month', true, true);
                          }}
                          // errors.date.value
                          errorDate={
                            touched.date && get(errors, 'date.value', false)
                          }
                          touchedDate={touched.date}
                          onBlurDate={() => {
                            setFieldTouched('date', true, true);
                          }}
                          errorMsg=""
                          type="dob"
                          datePickerContainerstyle={{
                            height: '50px'
                          }}
                          dropdownStyle={{
                            top: '50px'
                          }}
                        />
                      </div>
                      <div className="mb-10 md:mb-7  font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="voterId_No"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.voterId_No}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Voter ID No."
                          error={touched.voterId_No && errors.voterId_No}
                          errorMsg={errors.voterId_No}
                          touched={touched.voterId_No}
                        />
                      </div>
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="address_line1"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.address_line1}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Address Line 1"
                          error={touched.address_line1 && errors.address_line1}
                          errorMsg={errors.address_line1}
                          touched={touched.address_line1}
                        />
                      </div>
                      <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                        <CommonInput
                          name="address_line2"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={data.address_line2}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          legendName="Address Line 2"
                          error={touched.address_line2 && errors.address_line2}
                          errorMsg={errors.address_line2}
                          touched={touched.address_line2}
                        />
                      </div>
                      <div className={`${align_city_state}`}>
                        <div className=" mb-10 font-normal font-roboto text-sm text-black-500">
                          <CommonInput
                            name="city"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={data.city}
                            stylesContainer={{
                              maxWidth: '100%'
                            }}
                            legendName="City"
                            error={touched.city && errors.city}
                            errorMsg={errors.city}
                            touched={touched.city}
                          />
                        </div>
                        <div
                          className={`${align_state} mb-8 font-normal font-roboto text-sm text-black-500`}
                        >
                          <div className="text-black-600 font-roboto font-normal text-xs pb-1 md:py-0">
                            State
                          </div>

                          <CommonSelect sort={true}
                            name="state"
                            value={data.state}
                            onChange={e => {
                              setFieldValue('state', {
                                value: e.value,
                                label: e.value
                              });
                            }}
                            onBlur={() => {
                              setFieldTouched('state', true, true);
                            }}
                            options={StateListOptions}
                            isHoverEffect
                            stylesContainer={{
                              marginBottom: '0px',
                              fontSize: '40px',
                              height: '52px'
                            }}
                            dropdownStyle={{
                              top: '52px',
                              color: 'rgba(0,0,0,0.87)',
                              fontSize: '16px',
                              backgroundColor: '#fff',
                              alignItems: 'center',
                              fontFamily: 'Roboto',
                              fontWeight: 400
                            }}
                            styleText={{
                              fontSize: '14px',
                              padding: '0 6px',
                              backgroundColor: 'white'
                            }}
                            error={
                              touched.state && get(errors, 'state.value', false)
                            }
                            touched={touched.state}
                          />
                        </div>
                      </div>
                      <div>
                        <CommonPincode
                          name="pincode"
                          value={data.pincode}
                          onChange={e => {
                            if (
                              e.target.value.length <= 6 &&
                              !isNaN(e.target.value)
                            ) {
                              setFieldValue('pincodeCity', ''),
                                setFieldValue('pincodeState', '');
                              handleChange(e);
                            }
                          }}
                          stylesContainer={{
                            maxWidth: '100%'
                          }}
                          error={errors?.pincode && touched?.pincode}
                          errorMsg={errors?.pincode}
                          touched={touched?.pincode}
                          onPinCodeSucessOrFailure={obj => {
                            const { err, data: pincodeData } = obj;

                            if (!err && pincodeData) {
                              setFieldValue(
                                'pincodeCity',
                                pincodeData.District
                              ),
                                setFieldValue(
                                  'pincodeState',
                                  pincodeData.State
                                );
                            } else {
                              setFieldError('pincode', 'Pincode is not valid');
                            }
                          }}
                          onBlur={e => {
                            handleBlur(e);
                          }}
                        />
                        <p className="pt-3 text-green-500 text-xs">
                          {data.pincodeCity} {data.pincodeState}
                        </p>
                      </div>
                    </div>

                    <div>
                      <button
                        onClick={() => saveAndVerify()}
                        type="submit"
                        className={
                          ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
                        }
                        disabled={
                          errors.fullName ||
                          data.fullName == '' ||
                          errors.fatherName ||
                          data.fatherName == '' ||
                          errors.voterId_No ||
                          data.voterId_No == '' ||
                          data.date.value == '' ||
                          data.month.value == '' ||
                          data.year.value == '' ||
                          errors.month == '' ||
                          errors.year == '' ||
                          errors.date == '' ||
                          errors.address_line1 ||
                          data.address_line1 == '' ||
                          errors.address_line2 ||
                          data.address_line2 == '' ||
                          errors.city ||
                          data.city == '' ||
                          errors.state ||
                          data.state == '' ||
                          errors.pincode ||
                          data.pincode == '' ||
                          data.gender == ''
                        }
                      >
                        Save & Verify
                      </button>
                    </div>
                  </>
                )}
              </div>
            </Form>
          </React.Fragment>
        );
      }}
    </Formik>
  );
};

export default UserVoterDetails;
